import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { ReportVersion } from 'types/ModelTypes';
import { ReportActionButton, VersionHistoryRegion } from './Emission.style';
import { getReportVersionHistoryErrorMessage, ReportVersionHistoryError } from './reportVersionUtils';

type Props = {
    reportStatusId: number;
    isExpanded: boolean;
    isLoading: boolean;
    versions: ReportVersion[];
    error: ReportVersionHistoryError | null;
    onToggle: () => void;
    onDownload: (version: ReportVersion) => void;
};

const ReportVersionHistory: React.FC<Props> = ({ reportStatusId, isExpanded, isLoading, versions, error, onToggle, onDownload }) => {
    const historyId = `report-version-history-${reportStatusId}`;

    return (
        <>
            <ReportActionButton
                type="button"
                aria-expanded={isExpanded}
                aria-controls={historyId}
                aria-label={isExpanded ? 'Hide report version history' : 'Show report version history'}
                title={isExpanded ? 'Hide report version history' : 'Show report version history'}
                disabled={isLoading}
                onClick={(event) => {
                    event.stopPropagation();
                    onToggle();
                }}
            >
                <FontAwesomeIcon icon="clock-rotate-left" aria-hidden="true" />
            </ReportActionButton>
            {isExpanded && (
                <VersionHistoryRegion
                    id={historyId}
                    role="region"
                    aria-label="Report version history"
                    onClick={(event) => event.stopPropagation()}
                >
                    {isLoading && <p role="status">Loading version history...</p>}
                    {error && <p role="alert">{getReportVersionHistoryErrorMessage(error)}</p>}
                    {!isLoading && !error && versions.length === 0 && <p>No report versions are available.</p>}
                    {!isLoading && !error && versions.length > 0 && (
                        <ol>
                            {versions.map((version) => (
                                <li key={version.reportVersionId}>
                                    <span>
                                        <strong>Version {version.version}</strong>
                                        {version.isLatest && ' (Latest)'}: {version.fileName} ({new Date(version.generatedUtc).toLocaleString()})
                                    </span>{' '}
                                    <ReportActionButton
                                        type="button"
                                        aria-label={`Download Version ${version.version}`}
                                        title={`Download Version ${version.version}`}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            onDownload(version);
                                        }}
                                    >
                                        <FontAwesomeIcon icon="download" aria-hidden="true" />
                                    </ReportActionButton>
                                </li>
                            ))}
                        </ol>
                    )}
                </VersionHistoryRegion>
            )}
        </>
    );
};

export default ReportVersionHistory;
